import { isEmpty, orderBy } from 'lodash';
import { array } from 'prop-types';
import { useMemo } from 'react';

import { MultiActionButton, SanitizedHtml, Skeleton, Slide, Slider, StrapiImg, useHomePageContext } from 'components';
import { getModalContent } from 'helpers';

import 'assets/styles/components/informations-slider.scss';

const InformationsSlider = ({ slides }) => {
  const { loading: homePageLoading } = useHomePageContext();

  const orderedSlides = useMemo(() => orderBy(slides, 'order', ['asc']), [slides]);

  return (
    <div className="informations-slider">
      {homePageLoading && (
        <div className="h-[40rem] md:h-[25rem] lg:h-[30rem] 2xl:h-[35rem] w-full">
          <Skeleton classNames="w-full h-full object-cover" />
        </div>
      )}

      {!homePageLoading && !isEmpty(orderedSlides) && (
        <Slider type="loop" sliderClass="absolute-arrows top-right">
          {orderedSlides.map((information, i) => (
            <Slide
              slideClass="overflow-hidden h-[40rem] md:h-[25rem] lg:h-[30rem] 2xl:h-[35rem] relative"
              key={`slider-informations-${i}`}
            >
              <div className="image-container">
                <StrapiImg image={information.imageDesktop} mobileImage={information.imageMobile} />
              </div>

              <div className="text-container">
                <h2 className="h2 underlined-yellow">{information.title}</h2>

                <SanitizedHtml
                  content={information.description}
                  className="my-6 md:w-2/5 truncate-line five-lines lg:ten-lines 2xl:twelve-lines"
                />

                {!isEmpty(information?.cta) && (
                  <div className="flex justify-center md:justify-start">
                    {information.cta.map((cta, i) => (
                      <MultiActionButton
                        cta={cta}
                        index={i}
                        modalContent={() => getModalContent(information, i)}
                        key={`cta-action-${i}`}
                      />
                    ))}
                  </div>
                )}
              </div>
            </Slide>
          ))}
        </Slider>
      )}
    </div>
  );
};

InformationsSlider.propTypes = {
  slides: array
};

export default InformationsSlider;
